import React from 'react';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { AutoMedicalClaimsRuleRow } from './AutoMedicalClaimsRuleRow';
import { MAX_VISIBLE_RULES, sortRuleHits } from './ruleHitsHelpers';
import { MedicalClaim, RuleHit } from './types';

type AutoMedicalClaimsRuleHitsTableProps = {
  ruleHits: RuleHit[];
  claimsById: Record<number, MedicalClaim>;
  expandedRuleIds: string[];
  showAllRules: boolean;
  onToggleRuleClaims: (ruleId: string) => void;
  onToggleViewMore: () => void;
};

export const AutoMedicalClaimsRuleHitsTable = ({
  ruleHits,
  claimsById,
  expandedRuleIds,
  showAllRules,
  onToggleRuleClaims,
  onToggleViewMore,
}: AutoMedicalClaimsRuleHitsTableProps) => {
  const sortedRuleHits = sortRuleHits(ruleHits, claimsById);
  const visibleRuleHits = showAllRules
    ? sortedRuleHits
    : sortedRuleHits.slice(0, MAX_VISIBLE_RULES);
  const overflowCount = Math.max(0, sortedRuleHits.length - MAX_VISIBLE_RULES);

  return (
    <Table size="small" className="auto-medical-claims-rule-table">
      <TableHead>
        <TableRow className="auto-medical-claims-rule-head-row">
          <TableCell className="auto-medical-claims-rule-head-cell auto-medical-claims-rule-head-cell--expand" />
          <TableCell className="auto-medical-claims-rule-head-cell">
            Rule ID
          </TableCell>
          <TableCell className="auto-medical-claims-rule-head-cell">
            Modifier
          </TableCell>
          <TableCell className="auto-medical-claims-rule-head-cell">
            Rule Name
          </TableCell>
          <TableCell className="auto-medical-claims-rule-head-cell">
            Linked Claims
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {visibleRuleHits.map(rule => (
          <AutoMedicalClaimsRuleRow
            key={rule.id}
            rule={rule}
            claimsById={claimsById}
            isExpanded={expandedRuleIds.includes(rule.id)}
            onToggleRuleClaims={onToggleRuleClaims}
          />
        ))}

        {overflowCount > 0 && (
          <TableRow>
            <TableCell
              colSpan={5}
              className="auto-medical-claims-view-more-row-cell"
            >
              <Box
                component="button"
                onClick={onToggleViewMore}
                className="auto-medical-claims-view-more-button"
              >
                <span className="auto-medical-claims-view-more-icon">
                  {showAllRules ? '▼' : '▶'}
                </span>
                <span className="auto-medical-claims-view-more-text">
                  {showAllRules
                    ? `Hide ${overflowCount} rule${
                        overflowCount > 1 ? 's' : ''
                      }`
                    : `View ${overflowCount} more rule${
                        overflowCount > 1 ? 's' : ''
                      }`}
                </span>
              </Box>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
